<template>
  <tr>
    <td>
      <table class="table is-fullwidth">
        <tbody>
          <tr v-for="(item, index) in cells" :key="index">
            <table-cell-component
              :bus="bus"
              :cell_item="item">
            </table-cell-component>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
<script>
  import TableCellComponent from '@/components/layout/table/TableCellComponent'

  export default {
    name: 'table-row-dynamic-compact-component',
    props: {
      cells: {
        type: Array,
        required: true
      },
      index: {
        type: Number,
        required: true
      },
      bus: {
        type: Object,
        required: true
      }
    },
    components: {
      TableCellComponent
    },
    methods: {
      findRowForChild (element) {
        if (this.findChild(element, this.$children)) {
          this.bus.$emit('foundRowForChild', { child: element, row: this })
        }
      },
      findChild (element, children) {
        let found = false
        for (let child of children) {
          if (child === element) {
            return true
          } else {
            found = this.findChild(element, child.$children)
            if (found) { return found }
          }
        }
        return found
      }
    },
    created () {
      this.bus.$on('findRowForChild', this.findRowForChild)
    }
  }
</script>
